import React from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useToast } from 'providers/ToastProvider';
import Button from 'components/base/Button';
import { useExcluirNFe } from '../../../hooks/useNFe';

interface ModalExcluirNFeProps {
  show: boolean;
  onHide: () => void;
  nfeId: string;
  nfeNumero: number;
  redirectAfterDelete?: boolean; // Se true, redireciona para lista após deletar
}

const ModalExcluirNFe: React.FC<ModalExcluirNFeProps> = ({
  show,
  onHide,
  nfeId,
  nfeNumero,
  redirectAfterDelete = false,
}) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const mutation = useExcluirNFe();

  const handleExcluir = async () => {
    try {
      await mutation.mutateAsync(nfeId);
      showToast('NFe excluída com sucesso', 'success');
      onHide();

      if (redirectAfterDelete) {
        navigate('/operacional/nfe');
      }
    } catch (error: any) {
      console.error('Erro ao excluir NFe:', error);
      // Error handled by API interceptor
    }
  };

  const handleClose = () => {
    if (!mutation.isPending) {
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-bottom border-opacity-25">
        <Modal.Title className="text-body-emphasis">Excluir NFe</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-center mb-3">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            size="3x"
            className="text-warning"
          />
        </div>

        <Alert
          variant="warning"
          className="border border-warning border-opacity-25 bg-warning-subtle"
        >
          <div className="text-warning-emphasis">
            <strong>Atenção!</strong> Esta ação não pode ser desfeita.
          </div>
        </Alert>

        <p className="text-body-emphasis text-center">
          Tem certeza que deseja excluir a NFe <strong>#{nfeNumero}</strong>?
        </p>

        <p className="text-body-secondary text-center small mb-0">
          Todos os dados relacionados (destinatário, itens, duplicatas) serão permanentemente
          removidos.
        </p>
      </Modal.Body>

      <Modal.Footer className="border-top border-opacity-25">
        <Button variant="secondary" onClick={handleClose} disabled={mutation.isPending}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={handleExcluir}
          loading={mutation.isPending}
          loadingPosition="start"
        >
          {mutation.isPending ? 'Excluindo...' : 'Sim, Excluir'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalExcluirNFe;
